"use client";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { BodySnippet } from "./BodySnippet";
import { DocumentRoot } from "../../runtimes/react";
import { useRouterLocaleSync } from "../hooks/useRouterLocaleSync";
import { usePageSnippets } from "../hooks/usePageSnippets";
import { PageHead } from "./PageHead";
import { flattenMetadataSettings } from "./page-seo-settings";
function Page({ page, rootDocument, metadata = true }) {
  const { bodySnippets } = usePageSnippets({ page });
  const pageMetadataSettings = useMemo(() => flattenMetadataSettings(metadata), [metadata]);
  useRouterLocaleSync();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(PageHead, { document: page, metadata: pageMetadataSettings }),
    /* @__PURE__ */ jsx(DocumentRoot, { rootDocument }),
    bodySnippets.map((snippet) => /* @__PURE__ */ jsx(BodySnippet, { code: snippet.code, cleanup: snippet.cleanup }, snippet.id))
  ] });
}
export {
  Page
};
//# sourceMappingURL=Page.js.map